import { render } from "./your-profile-hero-component.vue?vue&type=template&id=a7b774ce"
import script from "./your-profile-hero-component.vue?vue&type=script&lang=js"
export * from "./your-profile-hero-component.vue?vue&type=script&lang=js"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__